import React from 'react';

const ContactSection = () => {
  return (
    <section 
      id="contact" 
      className="py-12 bg-gradient-to-b from-white via-green-50/20 to-white"
      aria-labelledby="contact-heading"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="space-y-4">
          <p className="text-lg text-gray-700">
            <span className="font-semibold text-green-800">Email:</span>{' '}
            <a href="mailto:raja@v-shesh.com" className="hover:text-green-800 hover:underline">raja@v-shesh.com</a>
            {' | '}
            <a href="mailto:rashi@v-shesh.com" className="hover:text-green-800 hover:underline">rashi@v-shesh.com</a>
            {' | '}
            <a href="mailto:shanthi.k@v-shesh.com" className="hover:text-green-800 hover:underline">shanthi.k@v-shesh.com</a>
          </p>
          <p className="text-lg text-gray-700">
            <span className="font-semibold text-green-800">Phone:</span>{' '}
            Rajasekharan: <a href="tel:+919600030311" className="hover:text-green-800 hover:underline">+91 9600030311</a>
            {' | '}
            Rashi: <a href="tel:+919643718789" className="hover:text-green-800 hover:underline">+91 9643718789</a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
